import { FC } from "react";
import {
  Box,
  Typography,
  Stack,
  TextField,
  InputAdornment,
} from "@mui/material";
import { tokens } from "@/tokens";
import type { EntrySummaryFiltersState } from "./EntrySummaryFilters";

interface RangeFilterProps {
  label: string;
  minKey: keyof EntrySummaryFiltersState;
  maxKey: keyof EntrySummaryFiltersState;
  prefix?: string;
  localFilters: EntrySummaryFiltersState;
  setLocalFilters: React.Dispatch<React.SetStateAction<EntrySummaryFiltersState>>;
}

const RangeFilter: FC<RangeFilterProps> = ({
  label,
  minKey,
  maxKey,
  prefix = "$",
  localFilters,
  setLocalFilters,
}) => (
  <Box>
    <Typography
      sx={{
        mb: 1,
        color: tokens.text.primary,
        fontWeight: tokens.fontWeight.semibold,
        fontSize: tokens.fontSize.base,
      }}
    >
      {label}
    </Typography>
    <Stack direction="row" spacing={1.5} alignItems="center">
      <TextField
        size="small"
        placeholder="Min"
        type="number"
        value={localFilters[minKey] as string}
        onChange={(e) =>
          setLocalFilters((prev) => ({
            ...prev,
            [minKey]: e.target.value,
          }))
        }
        InputProps={{
          startAdornment: prefix ? (
            <InputAdornment position="start">
              <Typography sx={{ fontSize: tokens.fontSize.base, color: tokens.text.secondary }}>
                {prefix}
              </Typography>
            </InputAdornment>
          ) : undefined,
        }}
        sx={{
          flex: 1,
          backgroundColor: tokens.bg.surface,
          "& .MuiInputBase-input": { fontSize: tokens.fontSize.base },
        }}
      />
      <Typography sx={{ color: tokens.text.muted, fontSize: tokens.fontSize.base }}>to</Typography>
      <TextField
        size="small"
        placeholder="Max"
        type="number"
        value={localFilters[maxKey] as string}
        onChange={(e) =>
          setLocalFilters((prev) => ({
            ...prev,
            [maxKey]: e.target.value,
          }))
        }
        InputProps={{
          startAdornment: prefix ? (
            <InputAdornment position="start">
              <Typography sx={{ fontSize: tokens.fontSize.base, color: tokens.text.secondary }}>
                {prefix}
              </Typography>
            </InputAdornment>
          ) : undefined,
        }}
        sx={{
          flex: 1,
          backgroundColor: tokens.bg.surface,
          "& .MuiInputBase-input": { fontSize: tokens.fontSize.base },
        }}
      />
    </Stack>
  </Box>
);

export default RangeFilter;
